import script from "./ViewConsultancyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewConsultancyPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewConsultancyPage.vue?vue&type=style&index=0&id=504ef6c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504ef6c4"]])

export default __exports__